import { IInventoryAdvancePaymentState } from '@/store/inventory-advance-payment';
import { IInventoryAdvancePaymentGetters } from './getters.types';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePayment,
  IUser,
  User,
  IInventoryAdvancePaymentData,
  IUserData,
  IMentionAttachmentComment,
  InventoryAdvancePaymentComment
} from '@/models';
import { Transition } from '@/models/transition';

export const getters: IInventoryAdvancePaymentGetters = {
  getInventoryAdvancePaymentCount(
    state: IInventoryAdvancePaymentState
  ): number {
    return state.count;
  },

  getInventoryAdvancePayments(
    state: IInventoryAdvancePaymentState
  ): IInventoryAdvancePayment[] {
    return state.inventoryAdvancePayments.map(
      (data: IInventoryAdvancePaymentData) => new InventoryAdvancePayment(data)
    );
  },

  getInventoryAdvancePaymentById: (state: IInventoryAdvancePaymentState) => (
    id: number
  ): IInventoryAdvancePayment | undefined => {
    const data = state.inventoryAdvancePayments.find(
      inventoryAdvancePayment => inventoryAdvancePayment.id === id
    );
    if (!data) {
      return undefined;
    }

    return new InventoryAdvancePayment(data);
  },

  getInventoryAdvancePaymentApprovers: (
    state: IInventoryAdvancePaymentState
  ): IUser[] => {
    return state.approvers.map((data: IUserData) => new User(data));
  },

  getInventoryAdvancePaymentCurrentAssignees: (
    state: IInventoryAdvancePaymentState
  ): IUser[] => {
    return state.currentAssignees.map((data: IUserData) => new User(data));
  },

  getInventoryAdvancePaymentFinanceManagers: (
    state: IInventoryAdvancePaymentState
  ): IUser[] => {
    return state.financeManagers.map((data: IUserData) => new User(data));
  },

  getInventoryAdvancePaymentAPSpecialists: (
    state: IInventoryAdvancePaymentState
  ): IUser[] => {
    return state.apSpecialists.map((data: IUserData) => new User(data));
  },

  getInventoryAdvancePaymentActivities: (
    state: IInventoryAdvancePaymentState
  ): Transition[] => {
    return state.activities;
  },

  getInventoryAdvancePaymentComments: (
    state: IInventoryAdvancePaymentState
  ): IMentionAttachmentComment[] => {
    return state.comments.map(data => new InventoryAdvancePaymentComment(data));
  },

  getInventoryAdvancePaymentCommentById: (
    state: IInventoryAdvancePaymentState
  ) => (id: number): IMentionAttachmentComment | undefined => {
    const data = state.comments.find(
      advancePayment => advancePayment.id === id
    );
    if (!data) {
      return undefined;
    }

    return new InventoryAdvancePaymentComment(data);
  },

  getLastCreatedInventoryAdvancePaymentCommentId(
    state: IInventoryAdvancePaymentState
  ): number | null {
    return state.lastCreatedInventoryAdvancePaymentCommentId;
  },

  // Mentions
  getInventoryAdvancePaymentMentionableUsers(
    state: IInventoryAdvancePaymentState
  ): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
